// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Y_ea","box":"WorkspacesBox_box__26tIG","node":"WorkspacesBox_node__2454t"};